import Http from "../http";

class ImageServices {
    static async getAllImages() {
        console.log('=================================================================i am in the userservices', )
        return Http.get('/getImageDetails');
      }
      static async createImages(data){
        return Http.post('/createNewImage',data)
      }
     static async updateImage(id,data){
        return Http.post(`/updateImage/${id}`,data)
     }
}
export default ImageServices;